import { camelCase } from 'lodash';

import { PortalWorkoutPlanFragment } from '@willow/graphql-iso/src/portal';
import { assertNever, DATE_FORMAT_LONG, formatWorkoutPlanType, gqlIsoDateFormat } from '@willow/shared-web';

import { PillLabel } from '../../../../pill-label/PillLabel';
import { PaymentAmountWrapper } from '../PaymentAmountWrapper';
import { PaymentDateWrapper } from '../PaymentDateWrapper';
import { PaymentStatusWrapper } from '../PaymentStatusWrapper';

export interface Props {
  activeWorkoutPlan: PortalWorkoutPlanFragment;
  amountDue: number;
}

export const WorkoutPlanHeader = ({ activeWorkoutPlan, amountDue }: Props) => {
  let headerLabel = '';
  switch (activeWorkoutPlan.__typename) {
    case 'ForbearanceWorkoutPlan':
      headerLabel = `Your loan is in ${camelCase(activeWorkoutPlan.forbearanceType)} forbearance`;
      break;
    case 'FlexModificationWorkoutPlan':
      headerLabel = `Your loan is in a trial flex modification`;
      break;
    case 'RepaymentWorkoutPlan':
      headerLabel = `Your loan is in a repayment plan`;
      break;
    case 'DefermentWorkoutPlan':
    case 'PaymentDeferralWorkoutPlan':
    case 'BankruptcyCh13WorkoutPlan':
      return <></>;
    default:
      assertNever(activeWorkoutPlan);
  }

  // Show first plan payment due with amount due as the due date
  const dueDate = activeWorkoutPlan.planPaymentsDue.find((p) => p.dStatus.amountRemaining > 0)?.paymentDate;

  if (amountDue === 0 || !dueDate) {
    return (
      <section id="payment-header" aria-label="Payment Due Details" className="text-center mb-4">
        <PaymentStatusWrapper className="u-bold">No Payment Due</PaymentStatusWrapper>
        <PaymentDateWrapper className="mt-3">{headerLabel}</PaymentDateWrapper>
      </section>
    );
  }

  return (
    <section id="payment-header" aria-label="Payment Due Details" className="text-center mb-4">
      <PaymentStatusWrapper>
        <PillLabel label={formatWorkoutPlanType(activeWorkoutPlan.type)} isError />
      </PaymentStatusWrapper>
      <PaymentAmountWrapper amount={amountDue} />

      <PaymentDateWrapper>{gqlIsoDateFormat(dueDate, DATE_FORMAT_LONG)}</PaymentDateWrapper>
    </section>
  );
};
